import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 100px;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n\n  svg {\n    display: block;\n  }\n\n  @media screen and (max-width: ", "px) {\n    width: 40px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100px;\n\n  @media screen and (max-width: ", "px) {\n    width: 40px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 600;\n  margin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: inherit;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  padding: 0 50px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n\n  @media screen and (max-width: ", "px) {\n    padding: 0 16px;\n    border-bottom: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 80px;\n  @media screen and (max-width: ", "px) {\n    height: 66px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { Heading2, Subheading } from '../Typography';
import styled from '../utils/styling/styled-components';
import { BACK_BUTTON } from '../utils/testing/TestIDs';
var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.breakpoints.sm;
});
var Container = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var TitleArea = styled.div(_templateObject3());
var Title = styled(Heading2).attrs({
  as: 'h1'
})(_templateObject4());
var Subtext = styled(Subheading).attrs({
  as: 'h3'
})(_templateObject5(), function (props) {
  return props.theme.colors.stone;
});
var Action = styled.div(_templateObject6(), function (props) {
  return props.theme.breakpoints.sm;
});
var BackButton = styled.button.attrs({
  dataTestid: BACK_BUTTON
})(_templateObject7(), function (props) {
  return props.theme.breakpoints.sm;
});
export var ActionStrip = function ActionStrip(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      action = _ref.action,
      onBack = _ref.onBack,
      _ref$hideBackButton = _ref.hideBackButton,
      hideBackButton = _ref$hideBackButton === void 0 ? false : _ref$hideBackButton,
      _ref$backIcon = _ref.backIcon,
      backIcon = _ref$backIcon === void 0 ? AcornsIcon.Icon.UtilityArrowLeft : _ref$backIcon,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(BackButton, {
    onClick: onBack,
    "data-testid": BACK_BUTTON
  }, !hideBackButton && /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: backIcon,
    width: "24px",
    height: "24px"
  })), /*#__PURE__*/React.createElement(TitleArea, null, title && /*#__PURE__*/React.createElement(Title, null, title), subtext && /*#__PURE__*/React.createElement(Subtext, null, subtext)), /*#__PURE__*/React.createElement(Action, null, action)));
};